import styled from 'styled-components';
import ButtonPrefab from '@sizeid/commons/components/Button';
import { media } from '@sizeid/commons/utils/styles';

import ContentWhiteBox from 'components/ContentWhiteBox';

export const StyledWhiteBox = styled(ContentWhiteBox)`
  width: 350px;
  margin: 4px;
`;
export const InnerContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Buttons = styled.div`
  margin-top: auto;
  a + a {
    button {
      margin-top: 0.5em;
    }
  }
`;

export const MinimizeImage = styled.img`
  align-self: center;
  justify-self: center;
  height: 45px;
`;

export const WhiteBoxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;

  ${media.moreThan('lg')`
    ${StyledWhiteBox} {
      width: 24%;
    }
  `}
`;

export const Button = styled(ButtonPrefab)`
  width: 100%;
`;
